export function GAME_NAVBAR_SPACE_BETWEEN_ITEMS(multiplier: number =  1) {
    return (15 * multiplier) + 'px';
}
export const GAME_NAVBAR_BUTTON_WIDTH = '20px';
export const GAME_NAVBAR_BUTTON_HEIGHT = '20px';